export const getNumbersFromValue = (value: string) => {
  if (!value) {
    return 0;
  }
  const regex = /[+-]?\d+(\.\d+)?/g;

  const res = value.match(regex)?.map((v) => parseFloat(v))[0];

  return res || 0;
};
